<p [class]="withAlert ? 'alert alert-info' : ''">
  <fa-icon *ngIf="withInfoSign" icon="info-circle"></fa-icon>
  {{ message || "There doesn't seem to be anything here." | translate }}
</p>
